import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

import { FuseMessageDialogComponent } from '@fuse/components/message-dialog/message-dialog.component';

@NgModule({
    declarations: [
        FuseMessageDialogComponent
    ],
    imports: [
        MatDialogModule,
        MatButtonModule
    ],
    entryComponents: [
        FuseMessageDialogComponent
    ],
})
export class FuseMessageDialogModule
{
}
